import React from 'react';
import {numberWithCommas} from "../../../utils/methods";
import {ReactComponent as Delete} from "../../../asset/icons/deleteIconDark.svg";

function FoodOrderItems({data, onClick}) {
  return (
    <li className='food-order-modal-list-item'>
      <div className='food-order-modal-list-item-box food-order-modal-list-item-title'>
        {data.title}
      </div>
      <div className='food-order-modal-list-item-box food-order-modal-list-item-count'>
        {data.count}
      </div>
      <div className='food-order-modal-list-item-box food-order-modal-list-item-price'>
        {numberWithCommas(data.price.toString())}
      </div>
      <button onClick={onClick}>
        <Delete/>
      </button>
    </li>
  );
}

export default FoodOrderItems;
